module.exports = __webpack_public_path__ + "static/media/wi.4d4712b6.png";